export const UNEXPLAINED_GAP_ID = "UnexplainedGap";
export const QUANTITY_UNEXPLAINED_GAP_ID = "unexplained-gap-serie";
export const CLASSIC_FAILURE = "classic-failure-serie-";
export const FAULT_IMPACT_SERIE = "failure-impact-serie";
export const MANUAL_FAILURE_IMPACT_SERIE = "manual-failure-impact-serie";
export const MANUAL_FAILURE = "manual-failure-serie";
